import React from 'react';
import Flash from 'react-reveal/Flash';

export default function BottomFiltersMenuHandler(props) {

    return (
        <div className="bottomFiltersMenuHandler">
            <div className="bottomFiltersMenuHandlerBar" />
            <Flash spy={props.qtde}>
                <div className="bottomFiltersMenuHandlerLabel">
                        {props.qtde} {props.qtde === 1 ? "resultado" : "resultados"}
                </div>
            </Flash>
        </div>
    );
}
